import _ from 'lodash';

const queues: Record<string, (...args: unknown[]) => void> = {};

export const saveQueue = {
  func(key: string, action: (...any: unknown[]) => void): (args) => void {
    return async (...args) => {
      delete queues[key];
      await action(...args);
      if (Object.keys(queues).length === 0) this.complete && this.complete();
    };
  },

  add(key: string, action: (args) => void, ...args: unknown[]): void {
    if (queues[key] == null) {
      this.pending && this.pending();
      queues[key] = _.debounce(this.func(key, action), 1000);
    }
    queues[key](...args);
  },

  pending: (): void => {
    return;
  },

  complete: (): void => {
    return;
  },

  isQueued(key: string): boolean {
    return key in queues;
  }
};
